import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card, CardBody, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Stack } from "@mui/material";
import Select from "react-select";
import { useDropzone } from "react-dropzone";
import { nanoid } from "nanoid";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReportDateRangeSelect, { getReportDateRange } from "layouts/ReportDateRangeSelect";
import DataTableLayout from "layouts/DatatableLayout";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { formatNumber, filterTextAndNum, formatMonthText } from "utils/HelperFunction";
import { getAllReportInvoiceMt, clearGetAllReportInvoiceMt } from "../../redux/handlers/report_invoice/getAllReportInvoiceMt.handler";
import { getAllReportInvoiceTt, clearGetAllReportInvoiceTt } from "../../redux/handlers/report_invoice/getAllReportInvoiceTt.handler";
moment.locale("th");
var generateMonthRange = function(start, end) {
    // ✅ 1. เช็คค่าว่าง
    if (!start || !end) return [];
    var startMoment = moment(start, "YYYY-MM-DD", true);
    var endMoment = moment(end, "YYYY-MM-DD", true);
    // ✅ 2. เช็ค format ถูกต้อง
    if (!startMoment.isValid() || !endMoment.isValid()) {
        return [];
    }
    // ✅ 3. กัน start > end
    if (startMoment.isAfter(endMoment)) {
        return [];
    }
    var result = [];
    var current = startMoment.clone().startOf("month");
    var last = endMoment.clone().startOf("month");
    // ✅ 4. กัน infinite loop (fail-safe)
    var safety = 0;
    var MAX_LOOP = 1000;
    while(current.isSameOrBefore(last)){
        result.push({
            month: current.format("YYYY-MM"),
            month_text: formatMonthText(current, "TH_SHORT")
        });
        current.add(1, "month");
        // 🔥 กัน loop ค้าง
        safety++;
        if (safety > MAX_LOOP) break;
    }
    return result;
};
var transformData = function(arrData) {
    return arrData.map(function(row) {
        // รองรับทั้ง months array และ data object
        var monthMap = {};
        if (row.data) {
            monthMap = row.data;
        } else if (row.months) {
            row.months.forEach(function(m) {
                monthMap[m.month] = m.total;
            });
        }
        return _object_spread_props(_object_spread({}, row), {
            monthMap: monthMap
        });
    });
};
// ===== helper: generate sticky CSS =====
var generateStickyCSS = function(count) {
    var css = "";
    var left = 0;
    for(var i = 1; i <= count; i++){
        var width = i === 1 ? 200 : 200; // ปรับตามจริงได้
        css += "\n      .fixed-header-table .rdt_TableHead .rdt_TableCol:nth-child(".concat(i, ") {\n        position: sticky;\n        left: ").concat(left, "px;\n        z-index: 5;\n        box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1) !important;\n      }\n\n      .fixed-header-table .rdt_TableBody .rdt_TableCell:nth-child(").concat(i, ") {\n        position: sticky;\n        left: ").concat(left, "px;\n        z-index: 3;\n        background: #fff;\n        box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1) !important;\n      }\n    ");
        left += width;
    }
    return css;
};
export function ReportSalesByStoreMt() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("md"));
    var _useState = _sliced_to_array(useState([]), 2), rowData = _useState[0], setRowData = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), pageId = _useState1[0], setPageId = _useState1[1];
    var _useState2 = _sliced_to_array(useState(10), 2), pageSize = _useState2[0], setPageSize = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), sortModel = _useState3[0], setSortModel = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), loading = _useState4[0], setLoading = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), totalPage = _useState5[0], setTotalPage = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), totalAmount = _useState6[0], setTotalAmount = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), schCusName = _useState7[0], setSchCusName = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), schCusCode = _useState8[0], setSchCusCode = _useState8[1];
    var _useState9 = _sliced_to_array(useState(moment().subtract({
        month: 5
    }).format("YYYY-MM-DD")), 2), schDocStart = _useState9[0], setSchDocStart = _useState9[1];
    var _useState10 = _sliced_to_array(useState(moment().format("YYYY-MM-DD")), 2), schDocEnd = _useState10[0], setSchDocEnd = _useState10[1];
    var _useState11 = _sliced_to_array(useState("custom"), 2), dateRange = _useState11[0], setDateRange = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), columns = _useState12[0], setColumns = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), monthCols = _useState13[0], setMonthCols = _useState13[1];
    var baseCols = [
        {
            name: "รหัสลูกค้า",
            selector: function(row) {
                return row.customer_code || "-";
            },
            minWidth: "200px",
            sortable: true,
            sortField: "customer_code",
            center: "true",
            style: {
                position: "sticky",
                left: 0,
                background: "#fff",
                zIndex: 3
            }
        },
        {
            name: "ชื่อลูกค้า",
            selector: function(row) {
                return row.customer_name || "-";
            },
            minWidth: "200px",
            sortable: true,
            sortField: "customer_name",
            style: !isMobile ? {
                position: "sticky",
                left: "200px",
                background: "#fff",
                zIndex: 3
            } : {}
        }
    ];
    var getAllReportInvoiceMtReducer = useAppSelector(function(state) {
        return state.getAllReportInvoiceMtReducer;
    });
    var fetchImportInvoices = function(param) {
        var customName = param.customName, customCode = param.customCode, dateDocStart = param.dateDocStart, dateDocEnd = param.dateDocEnd, pId = param.pId, pSize = param.pSize, sortField = param.sortField, sortValue = param.sortValue, resetList = param.resetList;
        // const qPageId = `pageId=${pId || "1"}`;
        // const qPageSize = `pageSize=${pSize || "10"}`;
        // const fullQuery = [
        //   qPageId,
        //   qPageSize,
        // ]
        //   .filter(Boolean)
        //   .join("&");
        var monthList = generateMonthRange(filterTextAndNum(dateDocStart) ? moment(dateDocStart).format("YYYY-MM-DD") : null, filterTextAndNum(dateDocEnd) ? moment(dateDocEnd).format("YYYY-MM-DD") : null);
        if (monthList && monthList.length > 0) {
            console.log("Generated month range:", monthList);
            setMonthCols(monthList.map(function(m, index) {
                return {
                    name: m.month_text,
                    selector: function(row) {
                        var _row_monthMap;
                        var _row_monthMap_m_month;
                        return (_row_monthMap_m_month = (_row_monthMap = row.monthMap) === null || _row_monthMap === void 0 ? void 0 : _row_monthMap[m.month]) !== null && _row_monthMap_m_month !== void 0 ? _row_monthMap_m_month : 0;
                    },
                    //sortable: true,
                    right: true,
                    minWidth: "200px",
                    // 🔥 sort จริง (สำคัญ)
                    sortFunction: function(a, b) {
                        var _a_monthMap, _b_monthMap;
                        var _a_monthMap_m_month;
                        var aVal = (_a_monthMap_m_month = (_a_monthMap = a.monthMap) === null || _a_monthMap === void 0 ? void 0 : _a_monthMap[m.month]) !== null && _a_monthMap_m_month !== void 0 ? _a_monthMap_m_month : 0;
                        var _b_monthMap_m_month;
                        var bVal = (_b_monthMap_m_month = (_b_monthMap = b.monthMap) === null || _b_monthMap === void 0 ? void 0 : _b_monthMap[m.month]) !== null && _b_monthMap_m_month !== void 0 ? _b_monthMap_m_month : 0;
                        return aVal - bVal;
                    },
                    cell: function(row, index, column, id) /*#__PURE__*/ {
                        var _row_monthMap;
                        var _row_monthMap_m_month;
                        return _jsx("div", {
                            className: "w-100 text-right",
                            children: formatNumber((_row_monthMap_m_month = (_row_monthMap = row.monthMap) === null || _row_monthMap === void 0 ? void 0 : _row_monthMap[m.month]) !== null && _row_monthMap_m_month !== void 0 ? _row_monthMap_m_month : 0) || "0.00"
                        });
                    }
                };
            }));
        } else {
            setMonthCols([]);
        }
        var dataQuery = _object_spread({
            customername: filterTextAndNum(customName) || null,
            customercode: filterTextAndNum(customCode) || null,
            startDate: filterTextAndNum(dateDocStart) ? moment(dateDocStart).format("YYYY-MM-DD") : null,
            endDate: filterTextAndNum(dateDocEnd) ? moment(dateDocEnd).format("YYYY-MM-DD") : null,
            pageId: pId || 1,
            pageSize: pSize || 10
        }, sortField && sortValue && {
            sortField: sortField,
            sortValue: sortValue
        });
        if (resetList) {
            setRowData([]);
        }
        dispatch(getAllReportInvoiceMt(dataQuery, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        var value = sortDirection; // 'asc' หรือ 'desc'
        console.log("Sort:", {
            sortField: field,
            sortValue: value
        });
        setSortModel({
            sortField: field,
            sortValue: value
        });
    };
    var reLoadData = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setPageId(1)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            setSortModel([])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function reLoadData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDateRangeChange = function(preset) {
        setDateRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setSchDocStart(moment(range.startDate).format("YYYY-MM-DD"));
            setSchDocEnd(moment(range.endDate).format("YYYY-MM-DD"));
            reLoadData();
        }
    };
    useEffect(function() {
        var init = function init() {
            return _init.apply(this, arguments);
        };
        function _init() {
            _init = _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    fetchImportInvoices({
                        dateDocStart: schDocStart,
                        dateDocEnd: schDocEnd,
                        pId: pageId,
                        pSize: pageSize
                    });
                    return [
                        2
                    ];
                });
            });
            return _init.apply(this, arguments);
        }
        init();
    }, []);
    useEffect(function() {
        fetchImportInvoices(_object_spread_props(_object_spread({
            customName: schCusName,
            customCode: schCusCode,
            dateDocStart: schDocStart,
            dateDocEnd: schDocEnd,
            pId: pageId,
            pSize: pageSize
        }, sortModel && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        }), {
            resetList: true
        }));
    }, [
        schCusName,
        schCusCode,
        schDocStart,
        schDocEnd,
        pageId,
        pageSize,
        sortModel
    ]);
    useEffect(function() {
        setIsLoading(getAllReportInvoiceMtReducer.isFetching);
        if (getAllReportInvoiceMtReducer.data && !getAllReportInvoiceMtReducer.isError) {
            var _datas_rows, _datas_rows1;
            var datas = getAllReportInvoiceMtReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            // const dataWithReplacements = Object.entries(datas).reduce(
            //     (acc, [key, value]) => {
            //         acc[key] = value === null ? "" : value;
            //             return acc;
            //         },
            //     {}
            // );
            if (datas && ((_datas_rows = datas.rows) === null || _datas_rows === void 0 ? void 0 : _datas_rows.length) && ((_datas_rows1 = datas.rows) === null || _datas_rows1 === void 0 ? void 0 : _datas_rows1.length) > 0) {
                setRowData(transformData(datas.rows));
                setColumns(_to_consumable_array(baseCols).concat(_to_consumable_array(monthCols)));
                var pagination = datas.pagination;
                setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPages) || 0);
                setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
            }
        }
    }, [
        getAllReportInvoiceMtReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงานยอดขายตามร้านค้า MT"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานยอดขายตามร้านค้า MT"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 3,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                            value: dateRange,
                                            onChange: handleDateRangeChange,
                                            groupClassName: "mb-3 mb-md-0 form-st-3 mt-0",
                                            controlHeight: 48
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 3,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 mb-md-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "วันที่เอกสารเริ่มต้น"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    inputFormat: "DD/MM/YYYY",
                                                    selected: schDocStart ? moment(schDocStart).toDate() : "",
                                                    onChange: function(date) {
                                                        setDateRange("custom");
                                                        if (moment(date).isValid()) {
                                                            setSchDocStart(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                        } else {
                                                            setSchDocStart("");
                                                        }
                                                        reLoadData();
                                                    },
                                                    placeholder: "DD/MM/YYYY",
                                                    className: "w-100 datepicker2",
                                                    value: schDocStart ? moment(schDocStart).format("DD/MM/YYYY") : ""
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 3,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 mb-md-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "วันที่เอกสารสิ้นสุด"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    inputFormat: "DD/MM/YYYY",
                                                    selected: schDocEnd ? moment(schDocEnd).toDate() : "",
                                                    onChange: function(date) {
                                                        setDateRange("custom");
                                                        if (moment(date).isValid()) {
                                                            setSchDocEnd(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                        } else {
                                                            setSchDocEnd("");
                                                        }
                                                        reLoadData();
                                                    },
                                                    placeholder: "DD/MM/YYYY",
                                                    className: "w-100 datepicker2",
                                                    value: schDocEnd ? moment(schDocEnd).format("DD/MM/YYYY") : ""
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 3,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 mb-md-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "รหัสลูกค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    placeholder: "ค้นหา รหัสลูกค้า",
                                                    onChange: function(e) {
                                                        setSchCusCode(e.target.value);
                                                        reLoadData();
                                                    },
                                                    value: schCusCode
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 3,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 mb-md-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ชื่อลูกค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    placeholder: "ค้นหา ชื่อลูกค้า",
                                                    onChange: function(e) {
                                                        setSchCusName(e.target.value);
                                                        reLoadData();
                                                    },
                                                    value: schCusName
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 12,
                                        lg: true
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "fixed-header-table",
                            style: {
                                overflowX: "auto"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                                    item: rowData,
                                    columns: columns,
                                    isSelectRows: false,
                                    currentPage: pageId,
                                    currentPageSize: pageSize,
                                    onChangePage: handleChangePage,
                                    onChangePageSize: handleChangeRowsPerPage,
                                    totalPage: totalPage,
                                    totalAmount: totalAmount,
                                    sortModel: sortModel,
                                    onChangeSort: setSortModel,
                                    handleSort: handleSort,
                                    loading: loading
                                }),
                                /*#__PURE__*/ _jsx("style", {
                                    children: generateStickyCSS(isMobile ? 1 : 2)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
export function ReportSalesByStoreTt() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("md"));
    var _useState = _sliced_to_array(useState([]), 2), rowData = _useState[0], setRowData = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), pageId = _useState1[0], setPageId = _useState1[1];
    var _useState2 = _sliced_to_array(useState(10), 2), pageSize = _useState2[0], setPageSize = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), sortModel = _useState3[0], setSortModel = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), loading = _useState4[0], setLoading = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), totalPage = _useState5[0], setTotalPage = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), totalAmount = _useState6[0], setTotalAmount = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), schCusName = _useState7[0], setSchCusName = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), schCusCode = _useState8[0], setSchCusCode = _useState8[1];
    var _useState9 = _sliced_to_array(useState(moment().subtract({
        month: 5
    }).format("YYYY-MM-DD")), 2), schDocStart = _useState9[0], setSchDocStart = _useState9[1];
    var _useState10 = _sliced_to_array(useState(moment().format("YYYY-MM-DD")), 2), schDocEnd = _useState10[0], setSchDocEnd = _useState10[1];
    var _useState11 = _sliced_to_array(useState("custom"), 2), dateRange = _useState11[0], setDateRange = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), columns = _useState12[0], setColumns = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), monthCols = _useState13[0], setMonthCols = _useState13[1];
    var baseCols = [
        {
            name: "รหัสลูกค้า",
            selector: function(row) {
                return row.customer_code || "-";
            },
            minWidth: "200px",
            sortable: true,
            sortField: "customer_code",
            center: "true",
            style: {
                position: "sticky",
                left: 0,
                background: "#fff",
                zIndex: 3
            }
        },
        {
            name: "ชื่อลูกค้า",
            selector: function(row) {
                return row.customer_name || "-";
            },
            minWidth: "200px",
            sortable: true,
            sortField: "customer_name",
            style: !isMobile ? {
                position: "sticky",
                left: "200px",
                background: "#fff",
                zIndex: 3
            } : {}
        }
    ];
    var getAllReportInvoiceTtReducer = useAppSelector(function(state) {
        return state.getAllReportInvoiceTtReducer;
    });
    var fetchImportInvoices = function(param) {
        var customName = param.customName, customCode = param.customCode, dateDocStart = param.dateDocStart, dateDocEnd = param.dateDocEnd, pId = param.pId, pSize = param.pSize, sortField = param.sortField, sortValue = param.sortValue, resetList = param.resetList;
        // const qPageId = `pageId=${pId || "1"}`;
        // const qPageSize = `pageSize=${pSize || "10"}`;
        // const fullQuery = [
        //   qPageId,
        //   qPageSize,
        // ]
        //   .filter(Boolean)
        //   .join("&");
        var monthList = generateMonthRange(filterTextAndNum(dateDocStart) ? moment(dateDocStart).format("YYYY-MM-DD") : null, filterTextAndNum(dateDocEnd) ? moment(dateDocEnd).format("YYYY-MM-DD") : null);
        if (monthList && monthList.length > 0) {
            setMonthCols(monthList.map(function(m, index) {
                return {
                    name: m.month_text,
                    selector: function(row) {
                        var _row_monthMap;
                        var _row_monthMap_m_month;
                        return (_row_monthMap_m_month = (_row_monthMap = row.monthMap) === null || _row_monthMap === void 0 ? void 0 : _row_monthMap[m.month]) !== null && _row_monthMap_m_month !== void 0 ? _row_monthMap_m_month : 0;
                    },
                    //sortable: true,
                    right: true,
                    minWidth: "200px",
                    // 🔥 sort จริง (สำคัญ)
                    sortFunction: function(a, b) {
                        var _a_monthMap, _b_monthMap;
                        var _a_monthMap_m_month;
                        var aVal = (_a_monthMap_m_month = (_a_monthMap = a.monthMap) === null || _a_monthMap === void 0 ? void 0 : _a_monthMap[m.month]) !== null && _a_monthMap_m_month !== void 0 ? _a_monthMap_m_month : 0;
                        var _b_monthMap_m_month;
                        var bVal = (_b_monthMap_m_month = (_b_monthMap = b.monthMap) === null || _b_monthMap === void 0 ? void 0 : _b_monthMap[m.month]) !== null && _b_monthMap_m_month !== void 0 ? _b_monthMap_m_month : 0;
                        return aVal - bVal;
                    },
                    cell: function(row, index, column, id) /*#__PURE__*/ {
                        var _row_monthMap;
                        var _row_monthMap_m_month;
                        return _jsx("div", {
                            className: "w-100 text-right",
                            children: formatNumber((_row_monthMap_m_month = (_row_monthMap = row.monthMap) === null || _row_monthMap === void 0 ? void 0 : _row_monthMap[m.month]) !== null && _row_monthMap_m_month !== void 0 ? _row_monthMap_m_month : 0) || "0.00"
                        });
                    }
                };
            }));
        } else {
            setMonthCols([]);
        }
        var dataQuery = _object_spread({
            customername: filterTextAndNum(customName) || null,
            customercode: filterTextAndNum(customCode) || null,
            startDate: filterTextAndNum(dateDocStart) ? moment(dateDocStart).format("YYYY-MM-DD") : null,
            endDate: filterTextAndNum(dateDocEnd) ? moment(dateDocEnd).format("YYYY-MM-DD") : null,
            pageId: pId || 1,
            pageSize: pSize || 10
        }, sortField && sortValue && {
            sortField: sortField,
            sortValue: sortValue
        });
        if (resetList) {
            setRowData([]);
        }
        dispatch(getAllReportInvoiceTt(dataQuery, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        var value = sortDirection; // 'asc' หรือ 'desc'
        console.log("Sort:", {
            sortField: field,
            sortValue: value
        });
        setSortModel({
            sortField: field,
            sortValue: value
        });
    };
    var reLoadData = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setPageId(1)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            setSortModel([])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function reLoadData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDateRangeChange = function(preset) {
        setDateRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setSchDocStart(moment(range.startDate).format("YYYY-MM-DD"));
            setSchDocEnd(moment(range.endDate).format("YYYY-MM-DD"));
            reLoadData();
        }
    };
    useEffect(function() {
        var init = function init() {
            return _init.apply(this, arguments);
        };
        function _init() {
            _init = _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    fetchImportInvoices({
                        dateDocStart: schDocStart,
                        dateDocEnd: schDocEnd,
                        pId: pageId,
                        pSize: pageSize
                    });
                    return [
                        2
                    ];
                });
            });
            return _init.apply(this, arguments);
        }
        init();
    }, []);
    useEffect(function() {
        fetchImportInvoices(_object_spread_props(_object_spread({
            customName: schCusName,
            customCode: schCusCode,
            dateDocStart: schDocStart,
            dateDocEnd: schDocEnd,
            pId: pageId,
            pSize: pageSize
        }, sortModel && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        }), {
            resetList: true
        }));
    }, [
        schCusName,
        schCusCode,
        schDocStart,
        schDocEnd,
        pageId,
        pageSize,
        sortModel
    ]);
    useEffect(function() {
        setIsLoading(getAllReportInvoiceTtReducer.isFetching);
        if (getAllReportInvoiceTtReducer.data && !getAllReportInvoiceTtReducer.isError) {
            var _datas_rows, _datas_rows1;
            var datas = getAllReportInvoiceTtReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            // const dataWithReplacements = Object.entries(datas).reduce(
            //     (acc, [key, value]) => {
            //         acc[key] = value === null ? "" : value;
            //             return acc;
            //         },
            //     {}
            // );
            if (datas && ((_datas_rows = datas.rows) === null || _datas_rows === void 0 ? void 0 : _datas_rows.length) && ((_datas_rows1 = datas.rows) === null || _datas_rows1 === void 0 ? void 0 : _datas_rows1.length) > 0) {
                setRowData(transformData(datas.rows));
                setColumns(_to_consumable_array(baseCols).concat(_to_consumable_array(monthCols)));
                var pagination = datas.pagination;
                setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPages) || 0);
                setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
            }
        }
    }, [
        getAllReportInvoiceTtReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงานยอดขายตามร้านค้า TT"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานยอดขายตามร้านค้า TT"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 3,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                            value: dateRange,
                                            onChange: handleDateRangeChange,
                                            groupClassName: "mb-3 mb-md-0 form-st-3 mt-0",
                                            controlHeight: 48
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 3,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 mb-md-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "วันที่เอกสารเริ่มต้น"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    inputFormat: "DD/MM/YYYY",
                                                    selected: schDocStart ? moment(schDocStart).toDate() : "",
                                                    onChange: function(date) {
                                                        setDateRange("custom");
                                                        if (moment(date).isValid()) {
                                                            setSchDocStart(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                        } else {
                                                            setSchDocStart("");
                                                        }
                                                        reLoadData();
                                                    },
                                                    placeholder: "DD/MM/YYYY",
                                                    className: "w-100 datepicker2",
                                                    value: schDocStart ? moment(schDocStart).format("DD/MM/YYYY") : ""
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 3,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 mb-md-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "วันที่เอกสารสิ้นสุด"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    inputFormat: "DD/MM/YYYY",
                                                    selected: schDocEnd ? moment(schDocEnd).toDate() : "",
                                                    onChange: function(date) {
                                                        setDateRange("custom");
                                                        if (moment(date).isValid()) {
                                                            setSchDocEnd(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                        } else {
                                                            setSchDocEnd("");
                                                        }
                                                        reLoadData();
                                                    },
                                                    placeholder: "DD/MM/YYYY",
                                                    className: "w-100 datepicker2",
                                                    value: schDocEnd ? moment(schDocEnd).format("DD/MM/YYYY") : ""
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 3,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 mb-md-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "รหัสลูกค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    placeholder: "ค้นหา รหัสลูกค้า",
                                                    onChange: function(e) {
                                                        setSchCusCode(e.target.value);
                                                        reLoadData();
                                                    },
                                                    value: schCusCode
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 3,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 mb-md-0 form-st-3 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ชื่อลูกค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    placeholder: "ค้นหา ชื่อลูกค้า",
                                                    onChange: function(e) {
                                                        setSchCusName(e.target.value);
                                                        reLoadData();
                                                    },
                                                    value: schCusName
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 12,
                                        lg: true
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "fixed-header-table",
                            style: {
                                overflowX: "auto"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                                    item: rowData,
                                    columns: columns,
                                    isSelectRows: false,
                                    currentPage: pageId,
                                    currentPageSize: pageSize,
                                    onChangePage: handleChangePage,
                                    onChangePageSize: handleChangeRowsPerPage,
                                    totalPage: totalPage,
                                    totalAmount: totalAmount,
                                    sortModel: sortModel,
                                    onChangeSort: setSortModel,
                                    handleSort: handleSort,
                                    loading: loading
                                }),
                                /*#__PURE__*/ _jsx("style", {
                                    children: generateStickyCSS(isMobile ? 1 : 2)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
